import * as React from "react";

const Download: React.FC = () => {
    return <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-85.000000, -237.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(5.000000, 7.000000)" id="UI-Icon/Glyph/download">
                    <g transform="translate(1.000000, 0.000000)">
                        <path d="M0,13 L14,13 L14,16 L0,16 L0,13 Z M12,7 L10.5,5.5 L7.994,8.006 L7.969,0 L6.062,0 L6.012,8.012 L3.5,5.5 L2,7 L7,12 L12,7 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Download);
